import classNames from 'classnames';
import React from 'react';

import styles from './indicatorCircle.scss';

interface IndicatorCircleProps {
  caption?: string;
  containerStyles?: string;
  isSelected?: boolean;
  shouldRender?: boolean;
}

export default function IndicatorCircle({
  caption,
  containerStyles,
  isSelected,
  shouldRender = true
}: IndicatorCircleProps) {
  if (!shouldRender) return null;
  const mainContainerStyles = classNames(
    styles.indicatorCircleContainer,
    containerStyles,
    'indicatorCircle'
  );
  const circleStyles = classNames(styles.circle, { [styles.circle_isSelected]: isSelected });
  const labelStyles = classNames(styles.label, { [styles.label_isSelected]: isSelected });
  return (
    <div aria-hidden className={mainContainerStyles}>
      <div className={circleStyles} />
      <span className={labelStyles} dangerouslySetInnerHTML={{ __html: caption }} />
    </div>
  );
}
